import React from 'react'

interface PdfSupplierProps {
  filePath: string
  width: string
  height: string
  title: string
}

export const PdfSupplier: React.FC<PdfSupplierProps> = ({
  filePath,
  width,
  height,
  title,
}) => {
  return (
    <div>
      <iframe src={filePath} width={width} height={height} title={title} />
    </div>
  )
}
